/* tslint:disable */
/* eslint-disable */
/**
 * WebCore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BCCADMINBaseModelsContentAnalysisRequest } from '../Models';
// @ts-ignore
import type { BCCADMINBaseModelsContentAnalysisResponse } from '../Models';
/**
 * AIApi - axios parameter creator
 */
export const AIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {BCCADMINBaseModelsContentAnalysisRequest} [bCCADMINBaseModelsContentAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAiAnalyzePost: async (bCCADMINBaseModelsContentAnalysisRequest?: BCCADMINBaseModelsContentAnalysisRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ai/analyze`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bCCADMINBaseModelsContentAnalysisRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAiComponentTranslatableFieldsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ai/component-translatable-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AIApi - functional programming interface
 */
export const AIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {BCCADMINBaseModelsContentAnalysisRequest} [bCCADMINBaseModelsContentAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAiAnalyzePost(bCCADMINBaseModelsContentAnalysisRequest?: BCCADMINBaseModelsContentAnalysisRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BCCADMINBaseModelsContentAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAiAnalyzePost(bCCADMINBaseModelsContentAnalysisRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.apiAiAnalyzePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAiComponentTranslatableFieldsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<string>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAiComponentTranslatableFieldsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIApi.apiAiComponentTranslatableFieldsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AIApi - factory interface
 */
export const AIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AIApiFp(configuration)
    return {
        /**
         * 
         * @param {BCCADMINBaseModelsContentAnalysisRequest} [bCCADMINBaseModelsContentAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAiAnalyzePost(bCCADMINBaseModelsContentAnalysisRequest?: BCCADMINBaseModelsContentAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<BCCADMINBaseModelsContentAnalysisResponse> {
            return localVarFp.apiAiAnalyzePost(bCCADMINBaseModelsContentAnalysisRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAiComponentTranslatableFieldsGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<string>; }> {
            return localVarFp.apiAiComponentTranslatableFieldsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AIApi - object-oriented interface
 */
export class AIApi extends BaseAPI {
    /**
     * 
     * @param {BCCADMINBaseModelsContentAnalysisRequest} [bCCADMINBaseModelsContentAnalysisRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAiAnalyzePost(bCCADMINBaseModelsContentAnalysisRequest?: BCCADMINBaseModelsContentAnalysisRequest, options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).apiAiAnalyzePost(bCCADMINBaseModelsContentAnalysisRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiAiComponentTranslatableFieldsGet(options?: RawAxiosRequestConfig) {
        return AIApiFp(this.configuration).apiAiComponentTranslatableFieldsGet(options).then((request) => request(this.axios, this.basePath));
    }
}

